module.exports = __webpack_public_path__ + "2a2a818fe9c80b09794ebd473fb46a0a.png";